module.exports = __webpack_public_path__ + "img/perfectiondetail_2.92fb18e.jpg";